import { FootTrafficOverlapData } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { fSimplePercentage } from '@utils/formatters';
import { baseChart } from './baseChart';
import { CA_COLOR_PALLETE } from '@utils/colorGenerator';
import Highcharts from 'highcharts';

export const buildChartOptions = (
  sortedDataItems: FootTrafficOverlapData[]
): Highcharts.Options => ({
  ...baseChart,

  legend: {
    align: 'left',
    layout: 'vertical',
    enabled: true,
    symbolRadius: 0,
    verticalAlign: 'middle',
  },

  plotOptions: {
    pie: {
      showInLegend: true,
    },
  },

  series: [
    {
      type: 'pie',
      dataLabels: {
        enabled: true,
        distance: -80,
        connectorWidth: 0,
        formatter() {
          return fSimplePercentage(this.y, {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          });
        },
        style: {
          textOutline: 'none',
          fontWeight: 'bold',
          color: '#FFFFFF',
        },
      },
      data: sortedDataItems.map((dataItem, index) => ({
        name: dataItem.name,
        y: dataItem.value,
        color: CA_COLOR_PALLETE[index],
      })),
    },
  ],

  tooltip: {
    enabled: true,
    headerFormat: '',
    pointFormatter() {
      return `${this.name}: ${fSimplePercentage(this.y, {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      })}`;
    },
  },
});
